import { render, staticRenderFns } from "./Certificado.vue?vue&type=template&id=9e35b4e2"
import script from "./Certificado.vue?vue&type=script&lang=js"
export * from "./Certificado.vue?vue&type=script&lang=js"
import style0 from "./Certificado.vue?vue&type=style&index=0&id=9e35b4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports